import { toRefs, ref, computed, nextTick } from 'vue';
import tinycolor from 'tinycolor2';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import Youtube from './component-lib.esm8.js';
import TwitchChannel from './component-lib.esm6.js';
import TwitchVideo from './component-lib.esm7.js';
import VimeoVideo from './component-lib.esm9.js';
import FacebookVideo from './component-lib.esm14.js';
import Kofi from './component-lib.esm5.js';
import Spotify from './component-lib.esm13.js';
import Soundcloud from './component-lib.esm11.js';
import AppleMusic from './component-lib.esm10.js';
import ApplePodcast from './component-lib.esm15.js';
import Calendly from './component-lib.esm12.js';
import CircularLoader from '../../components/circular-loader/component-lib.esm.js';
import RatioBox from '../../components/ratio-box/component-lib.esm.js';
import Lazy from '../../components/lazy/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { colors } from '../../styles/component-lib.esm.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  props: {
    options: {
      type: Object,
      required: true
    },
    embedType: {
      type: String,
      required: true
    },
    loaderColor: {
      type: String,
      default: null
    },
    linkUrl: {
      type: String,
      default: null
    },
    lazy: Boolean,
    isOpen: Boolean,
    id: String,
    trackVideoPlayEvents: Boolean
  },
  components: {
    Youtube,
    TwitchChannel,
    TwitchVideo,
    VimeoVideo,
    FacebookVideo,
    Kofi,
    Spotify,
    Soundcloud,
    AppleMusic,
    ApplePodcast,
    Calendly,
    RatioBox,
    CircularLoader,
    Lazy,
    ChevronIcon
  },
  computed: {
    classes() {
      return {
        'embed-container--is-open': this.isOpen
      };
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      options,
      embedType,
      loaderColor
    } = toRefs(props);
    const theme = useTheme();
    const customRatio = ref(null);
    const containerRef = ref(null);
    const selectedEmbedType = computed(() => options.value.embedTypes.find(o => o.value === embedType.value));
    const component = computed(() => {
      switch (options.value.id) {
        case 'youtube':
          return 'youtube';
        case 'twitch_channel':
          return 'twitch-channel';
        case 'twitch_video':
          return 'twitch-video';
        case 'vimeo_video':
          return 'vimeo-video';
        case 'facebook_video':
          return 'facebook-video';
        case 'kofi':
          return 'Kofi';
        case 'calendly':
          return 'Calendly';
        case 'spotify_track':
        case 'spotify_playlist':
        case 'spotify_artist':
        case 'spotify_album':
        case 'spotify_show':
        case 'spotify_episode':
          return 'Spotify';
        case 'soundcloud_track':
        case 'soundcloud_sets':
          return 'Soundcloud';
        case 'apple_track':
        case 'apple_album':
        case 'apple_playlist':
          return 'AppleMusic';
        case 'apple_podcast':
          return 'ApplePodcast';
      }
      return null;
    });
    const height = computed(() => {
      return selectedEmbedType.value.height;
    });
    const ratio = computed(() => {
      if (customRatio.value) return customRatio.value;
      return selectedEmbedType.value.ratio;
    });
    const showButtonStyles = computed(() => {
      return {
        '--c-open-color': tinycolor.mostReadable(theme.value.profile.btnBgColor, [theme.value.profile.btnColor], {
          includeFallbackColors: true
        }).toString()
      };
    });
    const openButtonText = computed(() => {
      return `Open in ${props.options.name}`;
    });
    async function handleResize() {
      await nextTick();
      const iframe = containerRef.value.querySelector('iframe');
      const {
        width,
        height
      } = iframe.getBoundingClientRect();
      const newRatio = width / height;
      customRatio.value = newRatio === 0 ? selectedEmbedType.value.ratio : newRatio;
    }
    function handleEmbedClick() {
      emit('event', {
        name: EVENTS.EMBED_CTA_CLICK,
        event_label: openButtonText.value
      });
    }
    const loaderColorLocal = computed(() => {
      if (loaderColor.value) return loaderColor.value;
      const btnBgColor = tinycolor(theme.value.profile.btnBgColor);
      return btnBgColor.isDark() ? colors.white : colors.black;
    });
    return {
      component,
      ratio,
      height,
      handleResize,
      containerRef,
      loaderColorLocal,
      showButtonStyles,
      openButtonText,
      handleEmbedClick
    };
  }
};
export { script as default };